import { DatePickerDate } from '@lyearn/ui';

import { DateFilterListItem } from '../constants';

export interface State {
  startTime: DatePickerDate;
  endTime: DatePickerDate;
  selectedItem?: DateFilterListItem;
  isCalendarOpen: boolean;
}

export enum ActionType {
  ClearDate = 'CLEAR_DATE',
  ClearList = 'CLEAR_LIST',
  SetCalendar = 'SET_CALENDAR',
  DateListItemClick = 'DATE_LIST_ITEM_CLICK',
}

export interface ClearDateAction {
  type: ActionType.ClearDate;
}

export interface ClearListAction {
  type: ActionType.ClearList;
}

export interface SetCalendarAction {
  type: ActionType.SetCalendar;
  payload: {
    value: boolean;
  };
}

export interface DateListItemClickAction {
  type: ActionType.DateListItemClick;
  payload: {
    value: DateFilterListItem;
  };
}

export type Action =
  | ClearDateAction
  | ClearListAction
  | DateListItemClickAction
  | SetCalendarAction;
